"use client";

import { Placeholder } from "@lmn/design-system";
import IconArrowLeft from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconArrowLeft.js";
import { Tab, TabNavButton, TabsRow, TabsViewport } from "./DurationTabsStyles";

// Reuses the real tab styled-components so the skeleton's height exactly matches
// the loaded tab row — the swap happens in place with no layout shift (CLS).
const SKELETON_TAB_COUNT = 5;

export default function DurationTabsSkeleton() {
  return (
    <TabsRow aria-hidden>
      <TabNavButton type="button" $disabled disabled tabIndex={-1}>
        <IconArrowLeft />
      </TabNavButton>

      <TabsViewport>
        {Array.from({ length: SKELETON_TAB_COUNT }).map((_, index) => (
          <Tab as="div" key={index}>
            <Placeholder width="40px" height="18px" />
            <Placeholder width="48px" height="14px" />
          </Tab>
        ))}
      </TabsViewport>

      <TabNavButton type="button" $disabled disabled tabIndex={-1}>
        <IconArrowLeft style={{ transform: "rotate(180deg)" }} />
      </TabNavButton>
    </TabsRow>
  );
}
